import { render, staticRenderFns } from "./PostStats.vue?vue&type=template&id=228ff858&"
import script from "./PostStats.vue?vue&type=script&lang=js&"
export * from "./PostStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports